import React from 'react';
import { Helmet } from 'react-helmet-async';
import SJ_LOGO from '../assets/images/SJ_Icon.png'; // Add your logo image

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogImage,
  canonical,
  type = 'website'
}) => {
  const siteUrl = 'https://shreejiambulance.in'; // Update with your actual domain
  const defaultTitle = 'Shreeji Ambulance - Trust in Every Mile | Since 2003';
  const defaultDescription = 'Shreeji Ambulance - Trusted Ambulance & Patient Transport Services Since 2003. Available across India from Ahmedabad. 24x7 Emergency Ambulance Service.';
  const defaultKeywords = 'ambulance service, patient transport, emergency ambulance, ICU ambulance, Ahmedabad ambulance, medical transport India, 24x7 ambulance, Shreeji Ambulance, ambulance service Ahmedabad, patient transfer service, ambulance service near me, Best ambulance service in Ahmedabad, Ambulance service in Ahmedabad';
  const defaultOgImage = SJ_LOGO; // Use the imported logo image

  const seoTitle = title ? `${title} | Shreeji Ambulance` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = ogImage || defaultOgImage;
  const seoCanonical = canonical || (typeof window !== 'undefined' ? `${siteUrl}${window.location.pathname}` : siteUrl);

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <link rel="canonical" href={seoCanonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seoCanonical} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:site_name" content="Shreeji Ambulance" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seoCanonical} />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Shreeji Ambulance" />
      <meta name="geo.region" content="IN-GJ" />
      <meta name="geo.placename" content="Ahmedabad" />
      <meta name="geo.position" content="23.0225;72.5714" />
      <meta name="ICBM" content="23.0225, 72.5714" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
    </Helmet>
  );
};

export default SEO;
